'use strict';

import { Utils } from 'poly-js-utils';
import _ from 'underscore';

export function isTargetInternalAndEmpty({ theme_data, profile, events, posts }, pageName) {
    const showEmptyEvents = Utils.selectBoxIsTrue(theme_data.events_page.include_empty_page || ['true']);
    const showEmptyNews = Utils.selectBoxIsTrue(theme_data.news_page.include_empty_page || ['true']);
    const showEmptyAboutMe = Utils.selectBoxIsTrue(theme_data.about_page.include_empty_page || ['true']);
    const showEmptyProducts = theme_data.products_page &&
        Utils.selectBoxIsTrue(theme_data.products_page.include_empty_page || ['true']);
    const showEmptyCareers = theme_data.careers_page &&
        Utils.selectBoxIsTrue(theme_data.careers_page.include_empty_page || ['true']);
    const showEmptyDisclaimers = theme_data.disclaimers_page &&
        Utils.selectBoxIsTrue(theme_data.disclaimers_page.include_empty_page || ['true']);
    const pages = {
        events: showEmptyEvents || Boolean(events && events.length),
        news: showEmptyNews || Boolean(posts && posts.length),
        about: showEmptyAboutMe || Boolean((profile.about_me_custom_content &&
            profile.about_me_custom_content.length) || (profile.team_members &&
                profile.team_members.length)
        ),
        products: showEmptyProducts || Boolean((profile.products_custom_content &&
            profile.products_custom_content.length) || (theme_data.products_page &&
                theme_data.products_page.custom_content &&
                theme_data.products_page.custom_content.length)
        )
        ,
        careers: showEmptyCareers || Boolean((profile.careers_custom_content &&
            profile.careers_custom_content.length) || (theme_data.careers_page &&
                theme_data.careers_page.custom_content &&
                theme_data.careers_page.custom_content.length)
        ),
        disclaimers: showEmptyDisclaimers || Boolean((theme_data.disclaimers_page &&
            theme_data.disclaimers_page.header_title &&
            theme_data.disclaimers_page.header_title.length)
        )
    };

    return pageName in pages ? pages[pageName] : true;
}

export function isContactModulePresent(themeData, currentPage) {
    let modules;

    if (currentPage || currentPage === '') {
        switch(currentPage) {
            case 'about-me':
            case 'about':
                modules = themeData.about_page.modules;
                break;
            case '.':
            case '':
                modules = themeData.home_page.modules;
                break;
            default:
                modules = themeData[`${currentPage}_page`].modules;
        }

        return Boolean(_.find(modules, (module) => module.module[0] === 'contactForm'));
    }
}

export function isNavElementCurrentPage(props, item) {
    return props.currentPage === item.url || (props.currentPage === '' && item.url === '.');
}

export const getContactFormPageUrl = (themeData, baseLink, contactHref = '#contact-form') => {
    if (isHomePageHasContactForm(themeData)) {
        return `${baseLink}${contactHref}`;
    }

    const navLinks = themeData.nav.main_navigation_links;
    for (let i = 0; i < navLinks.length; i++) {
        const pageUrl = navLinks[i].url;
        const isExternal = Utils.selectBoxIsTrue(navLinks[i].is_external || ['true']);
        if (!isExternal && isContactModulePresent(themeData, pageUrl)) {
            return `${baseLink}${pageUrl}${contactHref}`;
        }
    }

    return baseLink;
};

export const isHomePageHasContactForm = ({ home_page }) => {
    const { modules } = home_page;
    return modules.some(element => element.module[0] === 'contactForm');
};



// WEBPACK FOOTER //
// ./components/navigation/selectors.js